/* eslint-disable react/jsx-props-no-spreading */
import {useTranslation} from 'react-i18next';
import {useLocation, useNavigate, useParams} from 'react-router-dom';
import {useQuery, useQueryClient} from '@tanstack/react-query';
import {useEffect, useState} from 'react';
import {checkPermission, formatDateWithTime, formatMoney} from 'utils/utils';
import {apiStatus, defaultpageCount, integrationVendors, permissionKeys, routePaths, sortByTypeType} from 'utils/constants';
import {useSelector} from 'react-redux';
import {locationSelector, orgSelector, userSelector} from 'redux/selectors';
import useUser from 'hooks/useUser';
import ButtonBack from 'components/button/buttonBack';
import Buttons from 'components/button/Buttons';
import {Label, Table, TextInput, Tooltip} from 'flowbite-react';
import {
    createPurchaseOrder,
    createPurchaseOrderByMuscleFoods,
    getPurchaseOrderById,
    updatePurchaseOrderById
} from 'api/purchaseOrderApi';
import { getOrganizationIntegrationConfig } from 'api/organizationApi';
import {getItemById, getItemsByCategory, getItemsByFilter} from 'api/itemApi';
import { getOrgVendorsByFilter } from 'api/vendorApi';
import EmptyState from 'components/commonComponent/emptyState';
import {v4 as uuidv4} from 'uuid';
import {purchaseOrderItemType} from 'utils/proptypes';
import MultiSelect from 'components/select/index';
import {cloneDeep, concat, isEmpty, orderBy} from 'lodash';
import GroupButtonWithIcons from 'components/button/buttonGroupWithIcons';
import {HiOutlineExclamationCircle, HiOutlineTrash} from 'react-icons/hi';
import {toast} from 'react-toastify';
import './purchaseOrder.scss';
import CreateItemByCategoryModal from 'components/modal/purchaseOrderModal/createItemByCategoryModal';
import {initOrder} from 'utils/initData';
import Status from 'components/commonComponent/Status';
import ReviewBy from "../../components/commonComponent/reviewBy";
import axios from 'axios';
import urls from 'api/urls';
import {getLocationById} from 'api/locationApi';
import SpinnerComponent from 'components/spinner';
import StatisticsSaleModal from 'components/modal/purchaseOrderModal/statisticsSaleModal';
import {getStockByItemAndLocation, statisticsSaleItem} from 'api/stockApi';
import Sort from 'components/table/sort';
import MlvedaErrorModal from 'components/modal/purchaseOrderModal/mlvedaErrorModal';

type orderN2GProps = {
    id?: string,
    order: any
};

const PurchaseOrderReview = (props: any) => {
    const {type} = props;
    const {WRITE_PURCHASE_ORDER, PLATFORM_ADMIN} = permissionKeys;
    const location = useLocation();
    const navigate = useNavigate();
    const queryClient = useQueryClient();
    const params: any = useParams();
    const [data, setData] = useState<any[]>([]);
    const [itemTypeOptions, setItemTypeOptions] = useState<any[]>([{label: '...', value: null}]);
    const {userInfo} = useSelector(userSelector);
    const {organizationId} = useSelector(orgSelector);
    const {locationId} = useSelector(locationSelector);
    const { handleSetLocationTookie } = useUser();
    const {fetchCurrentUser} = useUser();
    const [searchValue, setSearchValue] = useState('');
    const [currentPage, setCurrentPage] = useState(0);
    const [pageCount, setPageCount] = useState(defaultpageCount);
    const [totalEntities, setTotalEntities] = useState(0);
    const [t] = useTranslation();
    const [sortBy, setSortBy] = useState('');
    const [sortByType, setSortByType] = useState('');
    const isWriteOrg = checkPermission(userInfo, props.type, [WRITE_PURCHASE_ORDER], organizationId);
    const itemEmpty = require('../../assets/image/svg/Emptys.svg').default || '';
    const [openModal, setOpenModal] = useState(false);
    const [openModalStatistics, setOpenModalStatistics] = useState(false);
    const [category, setCategory] = useState([]);
    const [targetPurchaseOrder, setTargetPurchaseOrder] = useState(initOrder);
    const [dataChart, setDataChart] = useState<any>(null);
    const [itemNameChart, setItemNameChart] = useState('');
    const [errorsN2G, setErrorsN2G] = useState<any>(null);
    const [isLoading, setIsLoading] = useState(false);
    const [isSaveDraft, setIsSaveDraft] = useState(false);
    const [orderTotal, setOrderTotal] = useState<number>(0);
    const [totalItem, setTotalItem] = useState<number>(0);
    const [openMlvedaErrorModal, setOpenMlvedaErrorModal] = useState(false);
    const [mlvedaError, setMlvedaError] = useState('');
    const [selectedVendorName, setSelectedVendorName] = useState<string>('');
    const [selectedVendorId, setSelectedVendorId] = useState<string>('');
    const pageCountDefault = 1000;
    const organizationVendorId = new URLSearchParams(location.search).get('organizationVendorId') || '';
    const [selectedVendorIntegration, setSelectedVendorIntegration] = useState<string>('');
    const isN2GIntegration = selectedVendorIntegration === integrationVendors.N2G_MLVEDA;
    const normalizedSelectedVendorName = (selectedVendorName || '').trim().toLowerCase();
    const isMuscleFoodsByName = normalizedSelectedVendorName === 'musclefoods' || normalizedSelectedVendorName === 'musclefood';
    const isMuscleFoodsIntegration =
        selectedVendorIntegration === integrationVendors.MUSCLEFOODS || isMuscleFoodsByName;
    const refreshPurchaseOrderViews = async () => {
        await queryClient.invalidateQueries(['getPurchaseOrders']);
        await queryClient.invalidateQueries(['getPurchaseOrderById']);
    };
    const extractMuscleFoodsOrderNumber = (response: any): string => {
        const data = response?.data || {};
        const candidates = [
            data?.orderHeader?.mfusaOrderNumber,
            data?.orderHeader?.orderNumber,
            data?.mfusaOrderNumber,
            data?.orderNumber,
            data?.id,
        ];
        const found = candidates.find((value: any) => value !== undefined && value !== null && String(value).trim() !== '');
        return found ? String(found) : '';
    };
    const isDotfitIntegration = selectedVendorIntegration === integrationVendors.DOTFIT;
    const resolveVendorNameByOrgVendorId = (targetOrganizationVendorId?: string) => {
        if (!targetOrganizationVendorId) {
            setSelectedVendorIntegration('');
            setSelectedVendorName('');
            setSelectedVendorId('');
            return;
        }
        getOrgVendorsByFilter({page: 0, limit: 1000, sortByType: sortByTypeType.DESC, organizationId}).then((res: any) => {
            const orgVendor = res?.data?.entities?.find((v: any) => v.id === targetOrganizationVendorId);
            setSelectedVendorIntegration(orgVendor?.integration || '');
            setSelectedVendorName(orgVendor?.name || '');
            setSelectedVendorId(orgVendor?.vendorId || '');
        }).catch(() => {
            setSelectedVendorIntegration('');
            setSelectedVendorName('');
            setSelectedVendorId('');
        });
    };
    const filterItemsBySelectedVendor = (items: any[] = []) => {
        if (!organizationVendorId) return items;
        return items.filter((item: any) => item?.organizationVendorId === organizationVendorId);
    };

    const { data: n2gIntegrationData } = useQuery(
        ['getOrganizationIntegrationConfig', organizationId, integrationVendors.N2G_MLVEDA],
        () => getOrganizationIntegrationConfig(organizationId, integrationVendors.N2G_MLVEDA),
        { enabled: !!organizationId && isN2GIntegration },
    );

    const n2gBaseUrl = n2gIntegrationData?.data?.siteUrl || process.env.REACT_APP_N2G_MLVEDA_API_URL || '';
    const n2gValidateUrl = n2gBaseUrl ? `${n2gBaseUrl}/order/validateOrder/` : urls.purchaseOrder.validateOrderN2G;
    const n2gCreateUrl = n2gBaseUrl ? `${n2gBaseUrl}/order/` : urls.purchaseOrder.creationOrderN2G;

    useEffect(() => {
        if (!organizationVendorId) {
            setSelectedVendorIntegration('');
            setSelectedVendorName('');
            setSelectedVendorId('');
            return;
        }
        getOrgVendorsByFilter({page: 0, limit: 1000, sortByType: sortByTypeType.DESC, organizationId}).then((res: any) => {
            const orgVendor = res?.data?.entities?.find((v: any) => v.id === organizationVendorId);
            setSelectedVendorIntegration(orgVendor?.integration || '');
            setSelectedVendorName(orgVendor?.name || '');
            setSelectedVendorId(orgVendor?.vendorId || '');
        }).catch(() => {
            setSelectedVendorIntegration('');
            setSelectedVendorName('');
            setSelectedVendorId('');
        });
    }, [organizationVendorId, organizationId]);

    useEffect(() => {
        if (params.id !== '') {
            setIsLoading(true);
            getPurchaseOrderById(params?.id).then((res: any) => {
                if (!organizationVendorId) {
                    const orderOrganizationVendorId = res?.data?.organizationVendorId || res?.data?.purchaseOrderItems?.[0]?.item?.organizationVendorId;
                    resolveVendorNameByOrgVendorId(orderOrganizationVendorId);
                }
                setTargetPurchaseOrder(res.data);
                setOrderTotal(res.data?.orderTotal || 0);
                setTotalItem(res.data?.purchaseOrderItems?.length);
                if (data?.length > 0 && data?.length !==  res.data?.purchaseOrderItems?.length) {
                    handleSortData();
                } else {
                    setData(res.data?.purchaseOrderItems?.map((item: any) => {
                        return {id: item.id, itemId: item.itemId, item: item.item, orderCount: item.quantityOrdered, quantityReceived: item.quantityReceived, quantityOnHand: item.quantityOnHand, quantityOnOrder: item.quantityOnOrder ?? 0, unitSoldLast7: item.unitSoldLast7, sixWeekAvg: item.sixWeekAvg}
                    }));
                    handleSortData();
                }
                if (isN2GIntegration && (res.data?.status === 'Draft' || res.data?.status === 'Requested')) {
                    //validate data to n2g
                    getLocationAndConvertLocationN2G(locationId).then((resLocation: any) => { 
                        const validateData: orderN2GProps = {
                            order: {
                                customer: getCustomerN2GWhenLoading(res.data),
                                location: resLocation,
                                items: convertItemToItemN2G(res.data?.purchaseOrderItems)
                            }
                        };
                        if (validateData.order?.location) {
                            const url = n2gValidateUrl;
                            axios.post(url, validateData, {headers: {'Access-Control-Allow-Origin': url, 'Accept': '*/*'}})
                                .then(response => {
                                    setErrorsN2G(null);
                                    setIsLoading(false);
                                })
                                .catch(error => {
                                    if (error?.response?.data?.errors || error?.response?.data?.location) {
                                        const errorsItems: any = [];
                                        for (let index = 0; index < error.response.data?.errors?.length; index++) {
                                            const element = error.response.data?.errors[index];
                                            for (let index = 0; index < element.errors?.length; index++) {
                                                const elementMsg = element.errors[index];
                                                elementMsg.sku = element.sku;
                                                if (element.quantityAvailable !== undefined) {
                                                    elementMsg.quantityAvailable = element.quantityAvailable;
                                                }
                                                errorsItems.push(elementMsg);
                                            }
                                        }
                                        const errorsLocation = error.response.data?.location?.errors;
                                        const errorsCustomer = error.response.data?.customer?.errors;
                                        const errorsList: any = {
                                            location: errorsLocation,
                                            items: errorsItems,
                                            customer: errorsCustomer
                                        }
                                        setErrorsN2G(errorsList);
                                        setIsLoading(false);
                                    }
                                });
                        }
                    });
                } else {
                    setIsLoading(false);
                }
            });
        } else {
            if (data?.length > 0) {
                handleSortData();
            } else {
                setData([]);
            }
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [params?.id, locationId, sortBy, sortByType, isN2GIntegration, organizationVendorId]);

    useEffect(() => {
        const setLocationSelect = async (idLocation: string) => {
            await handleSetLocationTookie(idLocation, organizationId);
        }
        if (targetPurchaseOrder && targetPurchaseOrder.locationId !== locationId) {
            const timeoutId = setTimeout(() => {
                setLocationSelect(targetPurchaseOrder?.locationId);
            }, 1000);
            
            return () => {
                clearTimeout(timeoutId);
            };
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[targetPurchaseOrder])

    const handleSortData = () => {
        if (sortBy && sortByType) {
            const sortType = sortByType === sortByTypeType.ASC ? 'asc' : 'desc';
            let sortedList: any = [];
            switch (sortBy) {
                case 'itemName':
                    sortedList = orderBy(data, ['item.name'], sortType);
                    break;
                case 'itemSku':
                    sortedList = orderBy(data, ['item.sku'], sortType);
                    break;
                case 'quantityOrdered':
                    sortedList = orderBy(data, ['orderCount'], sortType);
                    break;
                case 'itemCaseCost':
                    sortedList = orderBy(data, ['item.caseCost'], sortType);
                    break;
            }
            setData(sortedList);
        }
    }

    const handleHeaderSort = (field: string) => {
        setSortBy(field);
        let type = '';
        if (field !== sortBy) {
            type = sortByTypeType.ASC;
        } else if (sortByType === sortByTypeType.ASC) {
            type = sortByTypeType.DESC;
        } else {
            setSortBy(type);
        }
        setSortByType(type);
    };

    useEffect(() => {
        if (category.length > 0) {
            let ids: string = '';
            for (let index = 0; index < category.length; index++) {
                const id = category[index];
                if (ids === '') {
                    ids = id;
                } else {
                    ids = `${ids},${id}`;
                }
            }
            getItemsByCategory({categoryIds: ids, locationId, organizationVendorId}).then((res: any) => {
                if (res.data.totalEntities > 0) {
                    const vendorItems = filterItemsBySelectedVendor(res.data.entities);
                    if (data && data?.length > 0) {
                        const mergedItems = [...data,...vendorItems.map((item: any) => {
                            return {id: uuidv4(), itemId: item.id, item: item, orderCount: 1, quantityOnHand: item.quantityOnHand, quantityOnOrder: item.quantityOnOrder ?? 0, unitSoldLast7: item.unitSoldLast7, sixWeekAvg: item.sixWeekAvg};
                        })];
                        const uniqueItems = mergedItems.reduce((acc, item) => {
                            if (!acc.some((existingItem: any) => existingItem.itemId === item.itemId)) {
                              acc.push(item);
                            }
                            return acc;
                          }, []).filter((f: any) => f.item !== null);
                          setData(uniqueItems);
                          validateOrderN2G(locationId, uniqueItems);
                          calculationTotal(uniqueItems);
                    } else {
                        setData(
                            vendorItems.map((item: any) => {
                                return {id: uuidv4(), itemId: item.id, item: item, orderCount: 1, quantityOnHand: item.quantityOnHand, quantityOnOrder: item.quantityOnOrder ?? 0, unitSoldLast7: item.unitSoldLast7, sixWeekAvg: item.sixWeekAvg};
                            }),
                        );
                        validateOrderN2G(locationId, data);
                        calculationTotal(vendorItems.map((item: any) => {
                            return {id: uuidv4(), itemId: item.id, item: item, orderCount: 1, quantityOnHand: item.quantityOnHand, quantityOnOrder: item.quantityOnOrder ?? 0, unitSoldLast7: item.unitSoldLast7, sixWeekAvg: item.sixWeekAvg};
                        }));
                    }
                }
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [category]);

    const validateOrderN2G = (locationId: string, request: any) => {
        if (!isN2GIntegration) {
            setErrorsN2G(null);
            return;
        }
        //validate data to n2g
        getLocationAndConvertLocationN2G(locationId).then((resLocation: any) => { 
            const validateData: orderN2GProps = {
                order: {
                    customer: getCustomerN2G(),
                    location: resLocation,
                    items: convertItemToItemN2G(request)
                }
            };
            if (validateData.order?.location) {
                const url = n2gValidateUrl;
                axios.post(url, validateData, {headers: {'Access-Control-Allow-Origin': url, 'Accept': '*/*'}})
                    .then(response => {
                        setErrorsN2G(null);
                    })
                    .catch(error => {
                        if (error?.response?.data?.errors || error?.response?.data?.location) {
                            const errorsItems: any = [];
                            for (let index = 0; index < error.response.data?.errors?.length; index++) {
                                const element = error.response.data?.errors[index];
                                for (let index = 0; index < element.errors?.length; index++) {
                                    const elementMsg = element.errors[index];
                                    elementMsg.sku = element.sku;
                                    if (element.quantityAvailable !== undefined) {
                                        elementMsg.quantityAvailable = element.quantityAvailable;
                                    }
                                    errorsItems.push(elementMsg);
                                }
                            }
                            const errorsLocation = error.response.data?.location?.errors;
                            const errorsCustomer = error.response.data?.customer?.errors;
                            const errorsList: any = {
                                location: errorsLocation,
                                items: errorsItems,
                                customer: errorsCustomer
                            }
                            setErrorsN2G(errorsList);
                        }
                    });
            }
        });
    }

    const calculationTotal = (requestData: any) => {
        let sum = 0;
        for (let index = 0; index < requestData?.length; index++) {
            const element: any = requestData[index];
            sum = sum + ((element.orderCount || 0) * (element.item?.caseCost || 0));
        }
        setOrderTotal(sum);
        setTotalItem(requestData?.length);
    }

    useEffect(() => {
        if (!isN2GIntegration) return;
        if (errorsN2G?.location && errorsN2G?.location?.length > 0) {
            toast.error(`Location Error: ${buildErrorMessageN2G(errorsN2G.location)}`);
        }
        if (errorsN2G?.customer && errorsN2G?.customer?.length > 0) {
            toast.error(`Customer Error: ${buildErrorMessageN2G(errorsN2G.customer)}`);
        }
        // eslint-disable-next-line
    }, [errorsN2G, isN2GIntegration]);

    const fetchItems = async () => {
        if (!params?.id) return;
    
        let listTemps = [];
    
        try {
          const filterParams = {
            limit: pageCountDefault,
            sortByType: sortByTypeType.DESC,
            organizationId,
            locationId,
            organizationVendorId,
            vendorId: selectedVendorId,
            isActive: true, // Always filter to active items only for purchase orders
          };
    
          const res = await getItemsByFilter({ ...filterParams, page: 0 });
          const totalCount = res?.data?.totalEntities || 0;
    
          if (totalCount === 0) {
            setItemTypeOptions([]);
            return;
          }
    
          listTemps = filterItemsBySelectedVendor(res?.data?.entities || []);
    
          const pageBreak = Math.ceil(totalCount / pageCountDefault);
    
          for (let index = 1; index < pageBreak; index++) {
            const resPage = await getItemsByFilter({ ...filterParams, page: index });
            listTemps = [...listTemps, ...filterItemsBySelectedVendor(resPage?.data?.entities || [])];
          }
    
          const newOptions = listTemps.map((item: any) => ({
            label: item.name,
            value: { id: item.id, upcs: item.upcs },
          }));
    
          setItemTypeOptions(newOptions);
        } catch (error) {
          console.error('Error fetching items:', error);
          setItemTypeOptions([]);
        } finally {
          
        }
      };

    useEffect(() => {
        fetchItems();

        // eslint-disable-next-line
    }, [params?.id, organizationVendorId, selectedVendorId]);

    const handleUpdatePurchaseOrder = async (items: any, status: string) => {
        if (status !== 'Rejected' && hasDuplicateItemInRows(items)) {
            const message: string = t('orderPage.duplicateLineItemNotAllowed');
            toast.error(message);
            return;
        }
        let check = true;
        const payload: any = {
            name: targetPurchaseOrder.name,
            locationId: targetPurchaseOrder?.locationId,
            location: {id: targetPurchaseOrder?.locationId},
            organizationVendorId: organizationVendorId || targetPurchaseOrder?.organizationVendorId || '',
            status: status,
            requestedOn: targetPurchaseOrder.requestedOn ? targetPurchaseOrder.requestedOn : new Date(),
            requestedBy: targetPurchaseOrder.requestedBy ? targetPurchaseOrder.requestedBy : userInfo.id,
            requestedUser: {id: targetPurchaseOrder.requestedBy ? targetPurchaseOrder.requestedBy : userInfo.id},
            reviewedBy: userInfo.id,
            reviewedUser: {id: userInfo.id},
            purchaseOrderItems: items.map((i: any) => {
                return {
                    id: i.id,
                    itemId: i.itemId,
                    quantityOrdered: i.orderCount,
                    quantityReceived: 0
                }
            })
        }
        for (let index = 0; index < items.length; index++) {
            const rowItem: any = items[index];
            if (rowItem) {
                if (rowItem.itemId === '') {
                    check = false;
                } else {
                    if (rowItem.orderCount === 0) {
                        check = false;
                    }
                }
            }
        }

        if (isN2GIntegration && errorsN2G) {
            if (errorsN2G.items && errorsN2G.items.length > 0) {
                check = false;
            }

            if (errorsN2G.location && errorsN2G.location.length > 0) {
                check = false;
            }

            if (errorsN2G.customer && errorsN2G.customer.length > 0) {
                check = false;
            }
        }

        if (check === true) {
            setIsLoading(true);
            if (status === 'Ordered') {
                payload.orderedOn = new Date();
                const checkItemActive = items?.filter((x: any) => x.item?.isActive === false);
                if (checkItemActive && checkItemActive?.length > 0) {
                    const message: string = t('orderPage.errorInactiveItemOder');
                    toast.error(message);
                    setIsLoading(false);
                } else {
                    const checkMaxOrder = items?.filter((x: any) => x.item?.maxOrderQuantity && x.orderCount > x.item?.maxOrderQuantity);
                    if (checkMaxOrder && checkMaxOrder?.length > 0) {
                        const message: string = t('orderPage.updateCasesField');
                        toast.error(message);
                        setIsLoading(false);
                    } else if (isN2GIntegration) {
                        //validate data to n2g
                        getLocationAndConvertLocationN2G(locationId).then((resLocation: any) => { 
                            const validateData: orderN2GProps = {
                                order: {
                                    customer: getCustomerN2G(),
                                    location: resLocation,
                                    items: convertItemToItemN2G(items)
                                }
                            };
                            if (validateData.order?.location) {
                                const url = n2gValidateUrl;
                                axios.post(url, validateData, {headers: {'Access-Control-Allow-Origin': url, 'Accept': '*/*'}})
                                    .then(async response => {
                                        //submit po to n2g
                                        const creationData: orderN2GProps = {
                                            id: targetPurchaseOrder?.id,
                                            order: {
                                                customer: getCustomerN2G(),
                                                location: await getLocationAndConvertLocationN2G(targetPurchaseOrder?.locationId),
                                                items: convertItemToItemN2G(items)
                                            }
                                        };
                        
                                        const url = n2gCreateUrl;
                                        axios.post(url, creationData, {headers: {'Access-Control-Allow-Origin': url, 'Accept': '*/*'}})
                                            .then(async response => {
                                                let orderId = 0;
                                                if (response?.data?.orderID) {
                                                    orderId = response?.data?.orderID;
                                                }
                            payload.vendorOrderId = orderId.toString();
                                                await updatePurchaseOrderById(targetPurchaseOrder.id, payload);
                                                await refreshPurchaseOrderViews();
                                                setIsLoading(false);
                                                const message: string = t('orderPage.editSuccess');
                                                toast.success(message);
                                                fetchCurrentUser();
                                                navigate(-1);
                                            })
                                            .catch(async error => {
                                                //check Conflict order
                                                if (error?.response?.status === 409) {
                                                    let orderId = 0;
                                                    if (error?.response?.data?.orderData?.order_number) {
                                                        orderId = error?.response?.data?.orderData?.order_number;
                                                    }
                                                    payload.vendorOrderId = orderId.toString();
                                                    const orderItems: any = [];
                                                    for (let index = 0; index < error?.response?.data?.orderData?.line_items?.length; index++) {
                                                        const orderItem = error?.response?.data?.orderData?.line_items[index];
                                                        const findItem = payload.purchaseOrderItems?.find((i: any) => getItemSkuForVendor(i.item) === orderItem.sku);
                                                        if (findItem) {
                                                            findItem.quantityOrdered = orderItem.quantity;
                                                            orderItems.push(findItem);
                                                        }
                                                    }
                                                    payload.purchaseOrderItems = orderItems;
                                                    await updatePurchaseOrderById(targetPurchaseOrder.id, payload);
                                                    await refreshPurchaseOrderViews();
                                                    setIsLoading(false);
                                                    const message: string = t('orderPage.editSuccess');
                                                    toast.success(message);
                                                    fetchCurrentUser();
                                                    navigate(-1);
                                                } else {
                                                    if (error?.response?.data) {
                                                        const message = error?.response?.data?.length > 0 ? error?.response?.data[0].message : t('orderPage.editFail');
                                                        toast.error(message);
                                                    }
                                                    if (error?.message) {
                                                        toast.error(`${error?.message} from ${url}`);
                                                    }
                                                    setIsLoading(false);
                                                    const err = {
                                                        request: creationData,
                                                        response: error?.response?.data
                                                    }
                                                    setMlvedaError(JSON.stringify(err));
                                                    setOpenMlvedaErrorModal(!openMlvedaErrorModal);
                                                }
                                            });
                                    })
                                    .catch(error => {
                                        if (error?.response?.data?.errors || error?.response?.data?.location) {
                                            const errorsItems: any = [];
                                            for (let index = 0; index < error.response.data?.errors?.length; index++) {
                                                const element = error.response.data?.errors[index];
                                                for (let index = 0; index < element.errors?.length; index++) {
                                                    const elementMsg = element.errors[index];
                                                    elementMsg.sku = element.sku;
                                                    if (element.quantityAvailable !== undefined) {
                                                        elementMsg.quantityAvailable = element.quantityAvailable;
                                                    }
                                                    errorsItems.push(elementMsg);
                                                }
                                            }
                                            const errorsLocation = error.response.data?.location?.errors;
                                            const errorsCustomer = error.response.data?.customer?.errors;
                                            const errorsList: any = {
                                                location: errorsLocation,
                                                items: errorsItems,
                                                customer: errorsCustomer
                                            }
                                            setErrorsN2G(errorsList);
                                            setIsLoading(false);
                                        }
                                    });
                            }
                        });
                    } else if (isMuscleFoodsIntegration) {
                        try {
                            const locationResponse = await getLocationById(locationId);
                            const locationData = locationResponse?.data || {};
                            const customerNumber = (locationData?.customerNumber || '').trim();
                            const mfusaShipId = (locationData?.mfusaShipId || '').trim();
                            if (!customerNumber || !mfusaShipId) {
                                toast.error('Customer Number and Ship ID are required on the selected location for MuscleFoods orders.');
                                setIsLoading(false);
                                return;
                            }

                            const resolvedOrganizationVendorId = organizationVendorId || targetPurchaseOrder?.organizationVendorId || '';
                            const muscleFoodsLines = convertItemToItemMuscleFoods(items, resolvedOrganizationVendorId);
                            if (muscleFoodsLines.length === 0) {
                                toast.error('At least one valid MuscleFoods line item is required.');
                                setIsLoading(false);
                                return;
                            }

                            const missingItemData = muscleFoodsLines.some((line: any) => !line.item || !line.unitOfMeasure || !line.quantity);
                            if (missingItemData) {
                                toast.error('Each MuscleFoods line requires vendor SKU, quantity, and unit of measure.');
                                setIsLoading(false);
                                return;
                            }

                            const creationData = {
                                head: {
                                    customer: customerNumber,
                                    mfusaShipId,
                                    partnerPurchaseOrderNumber: targetPurchaseOrder?.id,
                                },
                                lines: muscleFoodsLines,
                            };
                            const createResponse = await createPurchaseOrderByMuscleFoods(creationData);
                            payload.vendorOrderId = extractMuscleFoodsOrderNumber(createResponse);
                            await updatePurchaseOrderById(targetPurchaseOrder.id, payload);
                            await refreshPurchaseOrderViews();
                            setIsLoading(false);
                            const message: string = t('orderPage.editSuccess');
                            toast.success(message);
                            fetchCurrentUser();
                            navigate(-1);
                        } catch (error: any) {
                            const errorMessage =
                                error?.response?.data?.message ||
                                error?.response?.data?.errors?.[0]?.detail ||
                                error?.message ||
                                t('orderPage.editFail');
                            toast.error(String(errorMessage));
                            setIsLoading(false);
                        }
                    } else {
                        try {
                            await updatePurchaseOrderById(targetPurchaseOrder.id, payload);
                        await refreshPurchaseOrderViews();
                            const message: string = t('orderPage.editSuccess');
                            toast.success(message);
                            fetchCurrentUser();
                            setIsLoading(false);
                            navigate(-1);
                        } catch (error: any) {
                            const hasMappedDotfitError = handleDotfitSubmitError(error);
                            if (!hasMappedDotfitError) {
                                const detail = error?.response?.data?.errors?.[0]?.detail;
                                toast.error(detail || t('orderPage.editFail'));
                            }
                            setIsLoading(false);
                        }
                    }
                }
            } else {
                payload.rejectedOn = status === 'Rejected' ? new Date() : null;
                const checkItemActive = items?.filter((x: any) => x.item?.isActive === false);
                if (checkItemActive && checkItemActive?.length > 0) {
                    const message: string = t('orderPage.errorInactiveItemOder');
                    toast.error(message);
                } else {
                    const checkMaxOrder = items?.filter((x: any) => x.item?.maxOrderQuantity && x.orderCount > x.item?.maxOrderQuantity);
                    if (checkMaxOrder && checkMaxOrder?.length > 0) {
                        const message: string = t('orderPage.updateCasesField')
                        toast.error(message);
                        setIsLoading(false);
                    } else {
                        try {
                            await updatePurchaseOrderById(targetPurchaseOrder.id, payload);
                            const message: string = t('orderPage.editSuccess');
                            toast.success(message);
                            fetchCurrentUser();
                            setIsLoading(false);
                            if (status === 'Requested') {
                                navigate(routePaths.PURCHASE_ORDER_PAGE);
                            } else {
                                navigate(-1);
                            }
                        } catch (error: any) {
                            const hasMappedDotfitError = handleDotfitSubmitError(error);
                            if (!hasMappedDotfitError) {
                                const detail = error?.response?.data?.errors?.[0]?.detail;
                                toast.error(detail || t('orderPage.editFail'));
                            }
                            setIsLoading(false);
                        }
                    }
                }
            }
        } else {
            if (status === 'Rejected') {
                payload.rejectedOn = new Date();
                await updatePurchaseOrderById(targetPurchaseOrder.id, payload);
                const message: string = t('orderPage.editSuccess');
                toast.success(message);
                fetchCurrentUser();
                setIsLoading(false);
                navigate(-1);
            } else {
                if (isN2GIntegration && errorsN2G?.location && errorsN2G?.location?.length > 0) {
                    toast.error(`Location Error: ${buildErrorMessageN2G(errorsN2G.location)}`);
                }
                if (isN2GIntegration && errorsN2G?.customer && errorsN2G?.customer?.length > 0) {
                    toast.error(`Location Error: ${buildErrorMessageN2G(errorsN2G.customer)}`);
                }
                toast.error(`${t('stockPage.requiredFieldMessage')}`);
                setIsLoading(false);
            }
        }
    };

    const handleSaveDraft = async (items: any) => {
        if (hasDuplicateItemInRows(items)) {
            const message: string = t('orderPage.duplicateLineItemNotAllowed');
            toast.error(message);
            return;
        }
        setIsSaveDraft(true);
        const resolvedOrganizationVendorId = organizationVendorId || targetPurchaseOrder?.organizationVendorId || '';
        let payload: any;
            if (targetPurchaseOrder.id !== '') {
                payload = {
                    name: targetPurchaseOrder.name,
                    locationId: locationId,
                    location: {id: locationId},
                    organizationVendorId: resolvedOrganizationVendorId,
                    status: 'Draft',
                    purchaseOrderItems: items.map((i: any) => {
                        return {
                            id: i.id,
                            itemId: i.itemId,
                            quantityOrdered: i.orderCount,
                            quantityReceived: 0
                        }
                    })
                }
            } else {
                payload = {
                    name: `Order By ${userInfo.firstName} ${userInfo.lastName}`,
                    locationId: locationId,
                    location: {id: locationId},
                    organizationVendorId: resolvedOrganizationVendorId,
                    status: 'Draft',
                    purchaseOrderItems: items.map((i: any) => {
                        return {itemId: i.itemId, quantityOrdered: i.orderCount, quantityReceived: 0};
                    }),
                };
            }

            const res = targetPurchaseOrder.id !== '' ? await updatePurchaseOrderById(targetPurchaseOrder.id, payload) : await createPurchaseOrder(payload);
            if (res.status >= apiStatus.SUCCESS) {
                const message: string = targetPurchaseOrder.id !== '' ? t('orderPage.editSuccess') : t('orderPage.saveSuccess');
                toast.success(message);
                fetchCurrentUser();
                setIsSaveDraft(false);
                navigate(-1);
            } else {
                toast.error(res.statusText);
                fetchCurrentUser();
                setIsSaveDraft(false);
            }
    };

    const handleAddRow = (item: any) => {
        const newRow: purchaseOrderItemType = {
            id: uuidv4(),
            itemId: '',
            item: null,
            orderCount: 1,
            quantityReceived: 0,
            quantityOnHand: 0,
            quantityOnOrder: 0,
            unitSoldLast7: 0,
            sixWeekAvg:  0
        };
        const newData: any = concat(data, newRow);
        setData(newData);
    };

    const handleAddItemByCategory = () => {
        setOpenModal(!openModal);
    };

    const handleDuplicatePO = async (payload: any) => {
        if (payload?.purchaseOrderItems?.length > 0) {
            setIsLoading(true);
            const request = {
                name: `Order By ${userInfo.firstName} ${userInfo.lastName} - Duplicate`,
                locationId: payload.locationId,
                location: {id: payload.locationId},
                organizationVendorId: payload.organizationVendorId || targetPurchaseOrder?.organizationVendorId || organizationVendorId || '',
                status: 'Draft',
                purchaseOrderItems: payload?.purchaseOrderItems?.map((i: any) => {
                    return {itemId: i.itemId, quantityOrdered: i.quantityOrdered, quantityReceived: 0};
                }),
            };

            const res = await createPurchaseOrder(request);
            if (res.status >= apiStatus.SUCCESS) {
                setIsLoading(false);
                const message: string = t('orderPage.duplicateSuccess');
                toast.success(message);
                navigate(`${routePaths.PURCHASE_ORDER_DETAIL}/${res.data?.id}`);
            } else {
                setIsLoading(false);
                toast.error(`${t('orderPage.duplicateFail')}`);
            }
        }
    }

    const handleRemoveAllInvalid = async () => {
        if (!isN2GIntegration) {
            removeInActiveItem();
            return;
        }
        if (errorsN2G) {
            if (data && data.length > 0) {
                const listContentClone = cloneDeep(data);
                const validateData: orderN2GProps = {
                    order: {
                        customer: getCustomerN2G(),
                        location: await getLocationAndConvertLocationN2G(targetPurchaseOrder?.locationId),
                        items: convertItemToItemN2G(listContentClone)
                    }
                };
                if (validateData.order?.location) {
                    const url = n2gValidateUrl;
                    await axios.post(url, validateData, {headers: {'Access-Control-Allow-Origin': url, 'Accept': '*/*'}})
                        .then(response => {
                            setErrorsN2G(null);
                            removeInActiveItem();
                        })
                        .catch(error => {
                            if (error?.response?.data?.errors || error?.response?.data?.location) {
                                const errorsItems: any = [];
                                for (let index = 0; index < error.response.data?.errors?.length; index++) {
                                    const element = error.response.data?.errors[index];
                                    for (let index = 0; index < element.errors?.length; index++) {
                                        const elementMsg = element.errors[index];
                                        elementMsg.sku = element.sku;
                                        if (element.quantityAvailable !== undefined) {
                                            elementMsg.quantityAvailable = element.quantityAvailable;
                                        }
                                        errorsItems.push(elementMsg);
                                    }
                                }
                                const errorsLocation = error.response.data?.location?.errors;
                                const errorsCustomer = error.response.data?.customer?.errors;
                                const errorsList: any = {
                                    location: errorsLocation,
                                    items: errorsItems,
                                    customer: errorsCustomer
                                }
                                const skuItems: any = errorsItems?.map((x: any) => x.sku);
                                removeItemsBy('item.sku', skuItems);
                                setErrorsN2G(null);
                            }
                        });
                }
            }
        } else {
            removeInActiveItem();
        }
    };

    const addRowFunc = () => {
        let check = true;
        for (let index = 0; index < data.length; index++) {
            const rowItem: any = data[index];
            if (rowItem) {
                if (rowItem.itemId === '') {
                    check = false;
                } else {
                    if (rowItem.orderCount === 0) {
                        check = false;
                    }
                }
            }
        }

        if (check === false) {
            toast.error(`${t('stockPage.requiredFieldMessage')}`);
        } else {
            const newRow: purchaseOrderItemType = {
                id: uuidv4(),
                itemId: '',
                item: null,
                orderCount: 1,
                quantityReceived: 0,
                quantityOnHand: 0,
                quantityOnOrder: 0,
                unitSoldLast7: 0,
                sixWeekAvg:  0
            };
            const newData: any = concat(data, newRow);
            setData(newData);
        }
    };

    const handleDeleteRow = (id: string, sku: string) => {
        const newData = data?.filter((d: any) => d.id !== id);
        setData(newData);
        let sum = 0;
        for (let index = 0; index < newData.length; index++) {
            const element: any = newData[index];
            sum = sum + ((element.orderCount || 0) * (element.item?.caseCost || 0));
        }
        setOrderTotal(sum);
        setTotalItem(newData?.length);
        const newItemsErrorsN2G = errorsN2G?.items?.filter((e: any) => e.sku !== sku);
        const newErrorsN2G = {
            location: errorsN2G?.location,
            items: newItemsErrorsN2G
        }
        setErrorsN2G(newErrorsN2G);
    };

    const getStatisticsCountSafe = async (itemId: string, targetLocationId: string, numDay: number): Promise<number> => {
        try {
            const res = await statisticsSaleItem(itemId, targetLocationId, numDay);
            return res?.data?.count || 0;
        } catch (error) {
            return 0;
        }
    };

    const getQuantityOnHandSafe = async (targetLocationId: string, itemId: string): Promise<number> => {
        try {
            const resStock = await getStockByItemAndLocation(targetLocationId, itemId);
            return resStock?.data?.quantityOnHand || 0;
        } catch (error) {
            return 0;
        }
    };

    const getQuantityOnOrderSafe = async (targetLocationId: string, itemId: string): Promise<number> => {
        try {
            const resStock = await getStockByItemAndLocation(targetLocationId, itemId);
            return resStock?.data?.quantityOnOrder ?? 0;
        } catch (error) {
            return 0;
        }
    };

    const handleStatictisItem = async (id: string, name: string) => {
        const chartCount = await getStatisticsCountSafe(id, targetPurchaseOrder?.locationId, 28);
        setDataChart({ count: chartCount });
        setItemNameChart(name);
        setOpenModalStatistics(!openModalStatistics);
    };

    const isDuplicateItemInAnotherRow = (rows: any[], currentRowId: string, itemId: string) =>
        rows.some((row: any) => row.id !== currentRowId && row.itemId === itemId);

    const hasDuplicateItemInRows = (rows: any[]) => {
        const selectedItemIds = rows
            .map((row: any) => row.itemId)
            .filter((itemId: string) => !!itemId);

        return new Set(selectedItemIds).size !== selectedItemIds.length;
    };

    const getItemOptionsForRow = (currentRowId: string) => {
        const selectedItemIds = new Set(
            data
                .filter((row: any) => row.id !== currentRowId && !!row.itemId)
                .map((row: any) => row.itemId),
        );

        return itemTypeOptions.filter((option: any) => {
            const optionItemId = option?.value?.id;
            return !optionItemId || !selectedItemIds.has(optionItemId);
        });
    };

    const handleChangeItem = async (id: string, option: any, field: any) => {
        const listContentClone = cloneDeep(data);
        const selectedItemId = option ? option.value?.id : '';
        if (field === 'itemId' && selectedItemId && isDuplicateItemInAnotherRow(listContentClone, id, selectedItemId)) {
            const message: string = t('orderPage.duplicateLineItemNotAllowed');
            toast.error(message);
            return;
        }
        const findContent: any = listContentClone?.find((item: any) => item.id === id);
        findContent[field] = selectedItemId;
        const res = await getItemById(selectedItemId);
        if (res.data) {
            findContent['item'] = res.data;
            findContent['orderCount'] = 1;
        }
        findContent["quantityOnHand"] = await getQuantityOnHandSafe(locationId, selectedItemId);
        findContent["quantityOnOrder"] = await getQuantityOnOrderSafe(locationId, selectedItemId);
        findContent["unitSoldLast7"] = await getStatisticsCountSafe(selectedItemId, locationId, 7);
        findContent["sixWeekAvg"] = await getStatisticsCountSafe(selectedItemId, locationId, 42);
        setData(listContentClone);
        if (isDotfitIntegration && errorsN2G?.items?.length > 0) {
            setErrorsN2G(null);
        }
        let sum = 0;
        for (let index = 0; index < listContentClone.length; index++) {
            const element: any = listContentClone[index];
            sum = sum + ((element.orderCount || 0) * (element.item?.caseCost || 0));
        }
        setOrderTotal(sum);
        setTotalItem(listContentClone?.length);

        if (!isN2GIntegration) return;

        const validateData: orderN2GProps = {
            order: {
                customer: getCustomerN2G(),
                location: await getLocationAndConvertLocationN2G(targetPurchaseOrder?.locationId),
                items: convertItemToItemN2G(listContentClone)
            }
        };
        if (validateData.order?.location) {
            const url = n2gValidateUrl;
            axios.post(url, validateData, {headers: {'Access-Control-Allow-Origin': url, 'Accept': '*/*'}})
                .then(response => {
                    setErrorsN2G(null);
                })
                .catch(error => {
                    if (error?.response?.data?.errors || error?.response?.data?.location) {
                        const errorsItems: any = [];
                        for (let index = 0; index < error.response.data?.errors?.length; index++) {
                            const element = error.response.data?.errors[index];
                            for (let index = 0; index < element.errors?.length; index++) {
                                const elementMsg = element.errors[index];
                                elementMsg.sku = element.sku;
                                if (element.quantityAvailable !== undefined) {
                                    elementMsg.quantityAvailable = element.quantityAvailable;
                                }
                                errorsItems.push(elementMsg);
                            }
                        }
                        const errorsLocation = error.response.data?.location?.errors;
                        const errorsCustomer = error.response.data?.customer?.errors;
                        const errorsList: any = {
                            location: errorsLocation,
                            items: errorsItems,
                            customer: errorsCustomer
                        }
                        setErrorsN2G(errorsList);
                    }
                });
        }
    };

    const handleChangeContentOverview = async (id: string, value: any, field: any) => {
        const listContentClone = cloneDeep(data);
        const findContent: any = listContentClone?.find((item: any) => item.id === id);
        if (field === 'orderCount') {
            const item = findContent['item'];
            findContent[field] = !isEmpty(value) ? parseInt(value) : 0;
        }
        setData(listContentClone);
        if (isDotfitIntegration && errorsN2G?.items?.length > 0) {
            setErrorsN2G(null);
        }
        let sum = 0;
        for (let index = 0; index < listContentClone.length; index++) {
            const element: any = listContentClone[index];
            sum = sum + ((element.orderCount || 0) * (element.item?.caseCost || 0));
        }
        setOrderTotal(sum);
        setTotalItem(listContentClone?.length);

        if (!isN2GIntegration) return;

        const validateData: orderN2GProps = {
            order: {
                customer: getCustomerN2G(),
                location: await getLocationAndConvertLocationN2G(targetPurchaseOrder?.locationId),
                items: convertItemToItemN2G(listContentClone)
            }
        };
        if (validateData.order?.location) {
            const url = n2gValidateUrl;
            axios.post(url, validateData, {headers: {'Access-Control-Allow-Origin': url, 'Accept': '*/*'}})
                .then(response => {
                    setErrorsN2G(null);
                })
                .catch(error => {
                    if (error?.response?.data?.errors || error?.response?.data?.location) {
                        const errorsItems: any = [];
                        for (let index = 0; index < error.response.data?.errors?.length; index++) {
                            const element = error.response.data?.errors[index];
                            for (let index = 0; index < element.errors?.length; index++) {
                                const elementMsg = element.errors[index];
                                elementMsg.sku = element.sku;
                                if (element.quantityAvailable !== undefined) {
                                    elementMsg.quantityAvailable = element.quantityAvailable;
                                }
                                errorsItems.push(elementMsg);
                            }
                        }
                        const errorsLocation = error.response.data?.location?.errors;
                        const errorsCustomer = error.response.data?.customer?.errors;
                        const errorsList: any = {
                            location: errorsLocation,
                            items: errorsItems,
                            customer: errorsCustomer
                        }
                        setErrorsN2G(errorsList);
                    }
                });
        }
    };

    const getItemSkuForVendor = (item: any, vendorIdOverride?: string) => {
        const vendorId = vendorIdOverride || item?.organizationVendorId;
        const vendorSku = vendorId ? item?.vendorConfig?.[vendorId]?.vendorSku : '';
        return (vendorSku || '').trim() || item?.sku;
    };

    const convertItemToItemN2G = (items: any) => {
        return items?.map((x: any) => {
            return {
                sku: getItemSkuForVendor(x.item),
                quantity: x.orderCount || x.quantityOrdered || 0
            }
        });
    };

    const convertItemToItemMuscleFoods = (items: any, organizationVendorIdForOrder: string) => {
        return (items || []).map((x: any) => {
            const itemSku = getItemSkuForVendor(x.item, organizationVendorIdForOrder);
            const unitOfMeasure = (x?.item?.vendorConfig?.[organizationVendorIdForOrder]?.unitOfMeasure || '').trim();
            return {
                item: itemSku,
                quantity: x.orderCount || x.quantityOrdered || 0,
                unitOfMeasure,
            };
        });
    };

    const getLocationAndConvertLocationN2G = async (locationId: string) => {
        const {NODE_ENV} = process.env;
        if (locationId) {
            const res = await getLocationById(locationId);
            const location = res?.data;
            return {
                name: NODE_ENV === "production" ? `${location?.organization?.name} ${location?.clubCode}` : `[TEST] ${location?.organization?.name} ${location?.clubCode}`,
                clubCode: location?.clubCode,
                address: location?.streetAddress1,
                address2: location?.streetAddress2,
                city: location?.city,
                state: location?.state,
                zip: location?.zipCode,
                country: "United States"
            }
        }
    };

    const getCustomerN2G = () => {
        return {
            name: targetPurchaseOrder?.requestedUser ? `${targetPurchaseOrder.requestedUser?.firstName} ${targetPurchaseOrder.requestedUser?.lastName}` : `${userInfo.firstName} ${userInfo.lastName}`,
            email: targetPurchaseOrder?.requestedUser ? targetPurchaseOrder.requestedUser?.emailAddress : userInfo.emailAddress
        }
    }

    const getCustomerN2GWhenLoading = (targetPo: any) => {
        return {
            name: targetPo?.requestedUser ? `${targetPo.requestedUser?.firstName} ${targetPo.requestedUser?.lastName}` : `${userInfo.firstName} ${userInfo.lastName}`,
            email: targetPo?.requestedUser ? targetPo.requestedUser?.emailAddress : userInfo.emailAddress
        }
    }

    const buildErrorMessageN2G = (errors: any) => {

        let message = '';
        for (let index = 0; index < errors.length; index++) {
            const element = errors[index];
            if (message === '') {
                message = element?.message;
            } else {
                message += `, ${element.message}`;
            }
        }
        ;

        return message;
    };

    const parseDotfitInventoryError = (detail: string) => {
        const insufficientInventoryPattern = /Insufficient DotFit inventory for "(.*)" \((.*)\)\. Requested (\d+), available (\d+)\./;
        const unavailableInventoryPattern = /Item "(.*)" \((.*)\) is unavailable in DotFit inventory/;

        const insufficientMatch = detail.match(insufficientInventoryPattern);
        if (insufficientMatch) {
            return {
                sku: insufficientMatch[2],
                quantityAvailable: Number(insufficientMatch[4]),
                message: '',
            };
        }

        const unavailableMatch = detail.match(unavailableInventoryPattern);
        if (unavailableMatch) {
            return {
                sku: unavailableMatch[2],
                message: detail,
            };
        }

        return null;
    };

    const handleDotfitSubmitError = (error: any) => {
        if (!isDotfitIntegration) return false;
        const detail = error?.response?.data?.errors?.[0]?.detail;
        if (!detail || typeof detail !== 'string') return false;

        const parsedError = parseDotfitInventoryError(detail);
        if (!parsedError) return false;

        setErrorsN2G({
            location: null,
            items: [parsedError],
            customer: null,
        });
        return true;
    };

    const getErrorItemN2G = (sku: string) => {
        if (!isN2GIntegration && !isDotfitIntegration) return '';
        let message = '';
        const errorItemBySku = errorsN2G?.items?.find((i: any) => i.sku === sku);
        if (errorItemBySku) {
            message = errorItemBySku.quantityAvailable !== undefined ? t('orderPage.itemN2GOutOfStock').replace('%quantity%', errorItemBySku.quantityAvailable) : errorItemBySku.message;
        }

        return message;
    }

    const customFilterOption = (option: any, inputValue: any) => {
        const label = option.label?.toLowerCase();
        const upc = option.value?.upcs?.find((x: any) => x?.upcCode?.includes(inputValue))?.upcCode?.toLowerCase();
        const input = inputValue.toLowerCase();
    
        return label?.includes(input) || upc?.includes(input);
    };

    //remove inactive item
    const removeInActiveItem = () => {
        setData(
            data.filter((entry: any) => entry.item?.isActive === true)
        );
    };
    // Generic function to remove items by a property
    const removeItemsBy = (property: string, valuesToRemove: any) => {
        const removeInactiveData = data.filter((entry: any) => entry.item?.isActive === true);
        setData(
            removeInactiveData.filter((entry) => {
            const row: any = entry;
            // Handle nested properties (e.g., item.id, item.sku)
            const value = property === 'item.sku'
            ? getItemSkuForVendor(row.item)
            : property.includes('.')
                ? property.split('.').reduce((obj: any, key: any) => obj[key], row)
                : row[property];
            return !valuesToRemove.includes(value);
        })
        );
    };

    return (
        <>
            <div className="flex flex-col w-full">
                <div className="flex relative xl:flex-row gap-4 flex-col w-full p-[15px] border-b border-gray-200 justify-between">
                    <ButtonBack buttonName={t('sidebar.purchaseOrder')}/>
                    <div className="text-primary text-lg font-semibold flex items-center">
                        <div className="text-lg">
                                <span className="gr">
                                    {selectedVendorName ? <span>{selectedVendorName}&nbsp;|&nbsp;</span> : null}
                                    <span className="font-normal">
                                        {t('orderPage.orderId').toUpperCase()}: &nbsp;
                                    </span>
                                    <span>{targetPurchaseOrder.vendorOrderId ? targetPurchaseOrder.vendorOrderId : targetPurchaseOrder.id}&nbsp;</span>
                                    <span className="font-normal">({new Intl.NumberFormat('en-US').format(
                                        totalItem,
                                    )} items)</span>&nbsp;| &nbsp;
                                </span>
                                <span className="gr">
                                    <span className="font-normal">
                                        {t('orderPage.total').toUpperCase()}:
                                    </span>
                                    <span>{formatMoney(orderTotal || 0)}</span>
                                </span>
                            </div>
                    </div>
                    <div className="flex md:gap-4 gap-2">
                        {targetPurchaseOrder.status === 'Requested'
                            ?
                            (
                                <>
                                    <Buttons className="text-white bg-yellow-500" onClick={() => isLoading ? {} : handleDuplicatePO(targetPurchaseOrder)}
                                                        text={t('orderPage.duplicated')}/>
                                    <Buttons className="text-white bg-secondary"
                                             onClick={() => handleUpdatePurchaseOrder(data, 'Rejected')}
                                             text={t('orderPage.reject')}/>
                                    <Buttons
                                        className="text-white bg-primary"
                                        onClick={() => isLoading ? {} : handleUpdatePurchaseOrder(data, 'Ordered')}
                                        text={t('orderPage.approved')}
                                    />
                                    {isN2GIntegration && (
                                        <Buttons className="text-white bg-red-500 w-[172px]" onClick={() => handleRemoveAllInvalid()}
                                                 text={t('orderPage.removeAllInvalid')}/>
                                    )}
                                </>
                            )
                            :
                            targetPurchaseOrder.status === 'Rejected'
                                ?
                                (
                                    <>
                                        <Buttons className="text-white bg-yellow-500" onClick={() => isLoading ? {} : handleDuplicatePO(targetPurchaseOrder)}
                                                        text={t('orderPage.duplicated')}/>
                                        <div
                                            className="bg-red-50 border border-dashed border-red-300 p-[10px] rounded-[2px]">
                                            <Status type={targetPurchaseOrder?.status}/>
                                        </div>
                                    </>
                                )
                                :
                                targetPurchaseOrder.status === 'Ordered'
                                    ?
                                    (
                                        <>
                                            <Buttons className="text-white bg-yellow-500" onClick={() => isLoading ? {} : handleDuplicatePO(targetPurchaseOrder)}
                                                        text={t('orderPage.duplicated')}/>
                                            <div
                                                className="bg-blue-50 border border-dashed border-blue-300 p-[10px] rounded-[2px]">
                                                <Status type={targetPurchaseOrder?.status}/>
                                            </div>
                                        </>
                                    )
                                    :
                                    targetPurchaseOrder.status === 'Received'
                                        ?
                                        (
                                            <>
                                                <Buttons className="text-white bg-yellow-500" onClick={() => isLoading ? {} : handleDuplicatePO(targetPurchaseOrder)}
                                                    text={t('orderPage.duplicated')}/>
                                                <div
                                                className="bg-green-50 border border-dashed border-green-300 p-[10px] rounded-[2px]">
                                                    <Status type={targetPurchaseOrder?.status}/>
                                                </div>
                                            </>

                                        )
                                        :
                                        targetPurchaseOrder.status === 'Partially Received'
                                        ?
                                        (
                                            <>
                                                <Buttons className="text-white bg-yellow-500" onClick={() => isLoading ? {} : handleDuplicatePO(targetPurchaseOrder)}
                                                    text={t('orderPage.duplicated')}/>
                                                <div
                                                    className="bg-gray-50 border border-dashed border-purple-300 p-[10px] rounded-[2px]">
                                                    <Status type={targetPurchaseOrder?.status}/>
                                                </div>
                                            </>

                                        )
                                        :
                                        (
                                            <>
                                                {isN2GIntegration && (
                                                    <Buttons className="text-white bg-red-500 w-[172px]" onClick={() => handleRemoveAllInvalid()}
                                                            text={t('orderPage.removeAllInvalid')}/>
                                                )}
                                                <div
                                                    className="bg-gray-50 border border-dashed border-gray-300 px-[12px] py-[5px] rounded-[2px]">
                                                    <Status type={targetPurchaseOrder?.status}/>
                                                </div>
                                            </>
                                        )
                        }
                    </div>
                </div>
                <div
                    className="status3column bg-gray-50 shadow-sm border-b bg-gray-50">
                    <div className="column1">
                        {targetPurchaseOrder.status !== 'Draft' && (<ReviewBy label="Requested On"
                                                                              content={formatDateWithTime(targetPurchaseOrder.requestedOn?.toString() || '')}/>)}
                        {targetPurchaseOrder.status !== 'Draft' && (
                            <ReviewBy label="Requested By" className="font-medium"
                                      content={targetPurchaseOrder.requestedUser?.firstName !== undefined ? `${targetPurchaseOrder.requestedUser?.firstName} ${targetPurchaseOrder.requestedUser?.lastName}` : `${userInfo.firstName} ${userInfo.lastName}`}/>)}
                    </div>
                    <div className="column2">
                        {(targetPurchaseOrder.status !== 'Requested' && targetPurchaseOrder.status !== 'Draft' && targetPurchaseOrder.status !== 'Rejected') && (<ReviewBy label="Ordered On"
                                                                                    content={formatDateWithTime(targetPurchaseOrder.orderedOn?.toString() || '')}/>)}
                        {targetPurchaseOrder.status !== 'Draft' && (
                            <ReviewBy label="Reviewed By" className="font-medium"
                                      content={targetPurchaseOrder.reviewedUser?.firstName !== undefined ? `${targetPurchaseOrder.reviewedUser?.firstName} ${targetPurchaseOrder.reviewedUser?.lastName}` : `${userInfo.firstName} ${userInfo.lastName}`}/>)}
                    </div>
                    <div className="column3">
                        {targetPurchaseOrder.status === 'Received' && (<ReviewBy label="Received On"
                                                                                 content={formatDateWithTime(targetPurchaseOrder.receivedOn?.toString() || '')}/>)}
                        {targetPurchaseOrder.status === 'Rejected' && (<ReviewBy label="Rejected On"
                                                                                 content={formatDateWithTime(targetPurchaseOrder.rejectedOn?.toString() || '')}/>)}
                        {targetPurchaseOrder.status === 'Received' && (
                            <ReviewBy label="Received By" className="font-medium"
                                      content={`${targetPurchaseOrder.receivedUser?.firstName} ${targetPurchaseOrder.receivedUser?.lastName}`}/>)}
                    </div>
                </div>
                <div className="purchase-order-detail overflow-x-auto" id="purchase-order-review-custom-portal">
                    {data && data.length === 0 ? (
                        <EmptyState
                            buttonName="Add Item"
                            handleAddClick={isWriteOrg && handleAddRow}
                            title={t('stockPage.titleNoItemResult')}
                            subtitle={t('itemPage.subTitleNoResult')}
                            icon={itemEmpty}
                        />
                    ) : (
                        <>
                            <Table>
                                <Table.Head className="text-gray-900 border-b border-gray-100 border-b-2 w-full">
                                    <Table.HeadCell
                                        className="cursor-pointer bg-white font-medium text-xs item px-0 pr-3 py-2"
                                        onClick={() => handleHeaderSort('itemName')}>
                                            <div className="flex items-center ">
                                                {t('itemPage.item')}
                                                <Sort check={sortBy === 'itemName'} sortByType={sortByType}/>
                                            </div>
                                    </Table.HeadCell>
                                    <Table.HeadCell
                                        className="cursor-pointer bg-white font-medium text-xs upc px-3 py-0"
                                        onClick={() => handleHeaderSort('itemSku')}>
                                            <div className="flex items-center ">
                                                {t('itemPage.sku').toUpperCase()}
                                                <Sort check={sortBy === 'itemSku'} sortByType={sortByType}/>
                                            </div>
                                    </Table.HeadCell>
                                    <Table.HeadCell
                                        className="cursor-pointer bg-white font-medium text-xs unit-pc px-3 py-0">
                                        {t('stockPage.count').toLocaleUpperCase()}
                                    </Table.HeadCell>
                                    <Table.HeadCell
                                        className="cursor-pointer bg-white font-medium text-xs unit-pc px-3 py-0">
                                        {t('orderPage.unitSoldLast7').toLocaleUpperCase()}
                                    </Table.HeadCell>
                                    <Table.HeadCell
                                        className="cursor-pointer bg-white font-medium text-xs unit-pc px-3 py-0">
                                        {t('orderPage.6weekavg').toLocaleUpperCase()}
                                    </Table.HeadCell>
                                    <Table.HeadCell
                                        className="cursor-pointer bg-white font-medium text-xs unit-pc px-3 py-0">
                                        {t('orderPage.incomingOrderQty').toLocaleUpperCase()}
                                    </Table.HeadCell>
                                    <Table.HeadCell
                                        className="cursor-pointer bg-white font-medium text-xs cases px-3 py-0"
                                        onClick={() => handleHeaderSort('quantityOrdered')}>
                                            <div className="flex items-center ">
                                                {t('orderPage.cases').toUpperCase()}
                                                <Sort check={sortBy === 'quantityOrdered'} sortByType={sortByType}/>
                                            </div>
                                    </Table.HeadCell>
                                    <Table.HeadCell
                                        className="cursor-pointer bg-white font-medium text-xs unit-pc px-3 py-0">
                                        {t('orderPage.received').toLocaleUpperCase()}
                                    </Table.HeadCell>
                                    <Table.HeadCell
                                        className="cursor-pointer bg-white font-medium text-xs cost-pc px-3 py-0"
                                        onClick={() => handleHeaderSort('itemCaseCost')}>
                                            <div className="flex items-center ">
                                                {t('orderPage.costPerCase').toLocaleUpperCase()}
                                                <Sort check={sortBy === 'itemCaseCost'} sortByType={sortByType}/>
                                            </div>
                                    </Table.HeadCell>
                                    <Table.HeadCell
                                        className="cursor-pointer bg-white font-medium text-xs unit-pc px-3 py-0">
                                        {t('orderPage.unitPerCase').toLocaleUpperCase()}
                                    </Table.HeadCell>
                                    <Table.HeadCell
                                        className="cursor-pointer bg-white font-medium text-xs total px-3 py-0">
                                        {t('orderPage.totalUnit').toLocaleUpperCase()}
                                    </Table.HeadCell>
                                    <Table.HeadCell
                                        className="cursor-pointer bg-white font-medium text-xs order px-3 py-0">
                                        {t('orderPage.totalOrder')}
                                    </Table.HeadCell>
                                    <Table.HeadCell
                                        className="cursor-pointer bg-white font-medium text-xs order px-3 py-0">
                                        {`Requested On`}
                                    </Table.HeadCell>
                                    <Table.HeadCell
                                        className="cursor-pointer bg-white font-medium text-xs order px-3 py-0">
                                        {`Ordered On`}
                                    </Table.HeadCell>
                                    <Table.HeadCell
                                        className="sticky right-0 bg-white font-medium text-xs action px-3 py-0 shadow-lg z-10">{''}
                                    </Table.HeadCell>
                                </Table.Head>
                                <Table.Body
                                    // className={cn('', {
                                    //   '--overflow': data?.length > 6,
                                    // })}
                                >
                                    {data.map((item: purchaseOrderItemType, index) => {
                                        return (
                                            <Table.Row key={`row-${item.id}`}
                                                       className="cursor-pointer bg-white text-sm hover:bg-gray-50 border-b border-gray-100">
                                                {item.itemId === '' ?
                                                    (
                                                        <Table.Cell className="px-0 pr-3 py-3 item">
                                                            <MultiSelect
                                                                onChange={(e: any) => {
                                                                    handleChangeItem(item?.id, e, 'itemId');
                                                                }}
                                                                options={getItemOptionsForRow(item.id)}
                                                                value={itemTypeOptions.find((i: any) => i.value?.id === item.itemId)}
                                                                id={`item-${index}`}
                                                                name={`item-${index}`}
                                                                noOptionsMessage={() => t('No options')}
                                                                closeMenuOnSelect
                                                                isHolderLabel={false}
                                                                isDisabled={
                                                                    targetPurchaseOrder.status === 'Ordered' ||
                                                                    targetPurchaseOrder.status === 'Rejected' ||
                                                                    targetPurchaseOrder.status === 'Received'
                                                                        ? true
                                                                        : false
                                                                }
                                                                filterOption={customFilterOption}
                                                                dropdownRoot={document.getElementById('purchase-order-review-custom-portal')}
                                                            />
                                                            <div
                                                                className={`text-red-600 text-xs font-normal mt-1 warning`}>{t('userManagementPage.requiredField')}</div>
                                                        </Table.Cell>
                                                    )
                                                    :
                                                    (
                                                        <Tooltip
                                                        content={itemTypeOptions.find((i: any) => i.value?.id === item.itemId) ? itemTypeOptions.find((i: any) => i.value?.id === item.itemId)?.label : ""}>
                                                            <Table.Cell className="px-0 pr-3 py-3 item">
                                                                <MultiSelect
                                                                    onChange={(e: any) => {
                                                                        handleChangeItem(item?.id, e, 'itemId');
                                                                    }}
                                                                    options={getItemOptionsForRow(item.id)}
                                                                    value={itemTypeOptions.find((i: any) => i.value?.id === item.itemId)}
                                                                    id={`item-${index}`}
                                                                    name={`item-${index}`}
                                                                    noOptionsMessage={() => t('No options')}
                                                                    closeMenuOnSelect
                                                                    isHolderLabel={false}
                                                                    isDisabled={
                                                                        targetPurchaseOrder.status === 'Ordered' ||
                                                                        targetPurchaseOrder.status === 'Rejected' ||
                                                                        targetPurchaseOrder.status === 'Received'
                                                                            ? true
                                                                            : false
                                                                    }
                                                                    filterOption={customFilterOption}
                                                                    dropdownRoot={document.getElementById('purchase-order-review-custom-portal')}
                                                                />
                                                                {item.item?.isActive === false && (
                                                                    <div className={`text-red-600 text-xs font-normal mt-1 warning`}>{t('itemPage.inactiveItem')}
                                                                    </div>
                                                                )}
                                                            </Table.Cell>
                                                        </Tooltip>
                                                    )
                                                }
                                                <Table.Cell className="px-3 py-3 upc">
                                                    <Label>{getItemSkuForVendor(item?.item)}</Label>
                                                    {getErrorItemN2G(getItemSkuForVendor(item?.item)) !== ''
                                                        ?
                                                        (<div
                                                            className={`text-red-600 text-xs font-normal mt-1 warning`}>{getErrorItemN2G(getItemSkuForVendor(item?.item))}</div>)
                                                        :
                                                        ('')
                                                    }
                                                </Table.Cell>
                                                <Table.Cell className="px-3 py-3 unit-pc">
                                                    <Label>{item?.quantityOnHand || 0}</Label>
                                                </Table.Cell>
                                                <Table.Cell className="px-3 py-3 unit-pc">
                                                    <Label>{item?.unitSoldLast7 || 0}</Label>
                                                </Table.Cell>
                                                <Table.Cell className="px-3 py-3 avg-week">
                                                    <Label>{item?.sixWeekAvg || 0}</Label>
                                                </Table.Cell>
                                                <Table.Cell className="px-3 py-3 unit-pc">
                                                    <Label>{item?.quantityOnOrder ?? 0}</Label>
                                                </Table.Cell>
                                                <Table.Cell className="px-3 py-3 cases">
                                                    <TextInput
                                                        type="number"
                                                        min={1}
                                                        max={item?.item?.maxOrderQuantity || undefined}
                                                        className="custom-input-count"
                                                        id={`orderCount-${index}`}
                                                        name={`orderCount-${index}`}
                                                        value={item?.orderCount}
                                                        onChange={(e: any) => {
                                                            handleChangeContentOverview(item?.id, e.target.value, 'orderCount');
                                                        }}
                                                        disabled={
                                                            targetPurchaseOrder.status === 'Ordered' ||
                                                            targetPurchaseOrder.status === 'Rejected' ||
                                                            targetPurchaseOrder.status === 'Received'
                                                                ? true
                                                                : false
                                                        }
                                                    />
                                                    {item.orderCount === 0 ? (
                                                        <div
                                                            className={`text-red-600 text-xs font-normal mt-1 warning`}>
                                                            {t('userManagementPage.requiredField')}
                                                        </div>
                                                    ) : (
                                                        ''
                                                    )}
                                                    {item.item?.maxOrderQuantity && (item.orderCount || 0) > item.item?.maxOrderQuantity ? (
                                                        <div
                                                            className={`text-red-600 text-xs font-normal mt-1 warning`}>
                                                            Max Order: {item.item?.maxOrderQuantity}
                                                        </div>
                                                    ) : (
                                                        ''
                                                    )}
                                                </Table.Cell>
                                                <Table.Cell className="px-3 py-3 unit-pc">
                                                    <Label>{item?.quantityReceived || 0}</Label>
                                                </Table.Cell>
                                                <Table.Cell className="px-3 py-3 cost-pc">
                                                    <Label>{formatMoney(item?.item?.caseCost)}</Label>
                                                </Table.Cell>
                                                <Table.Cell className="px-3 py-3 unit-pc">
                                                    <Label>{item?.item?.upcs?.find((x: any) => x.default === true)?.caseQuantity}</Label>
                                                </Table.Cell>
                                                <Table.Cell className="px-3 py-3 total">
                                                    <Label>{item?.orderCount ? item?.orderCount * item?.item?.upcs?.find((x: any) => x.default === true)?.caseQuantity : 0}</Label>
                                                </Table.Cell>
                                                <Table.Cell className="px-3 py-3 order">
                                                    <Label>{formatMoney((item?.orderCount || 0) * (item?.item?.caseCost))}</Label>
                                                </Table.Cell>
                                                <Table.Cell className="px-3 py-3 order">
                                                    <Label>{formatDateWithTime(targetPurchaseOrder.requestedOn?.toString() || '')}</Label>
                                                </Table.Cell>
                                                <Table.Cell className="px-3 py-3 order">
                                                    <Label>{formatDateWithTime(targetPurchaseOrder.orderedOn?.toString() || '')}</Label>
                                                </Table.Cell>
                                                <Table.Cell className="sticky right-0 bg-white px-3 py-3 action shadow-lg z-10">
                                                    <GroupButtonWithIcons
                                                        className="items-center justify-center"
                                                        buttons={[
                                                            {
                                                                type: 'button',
                                                                text: '',
                                                                classType: 'white',
                                                                icon: <HiOutlineTrash size={'20px'}/>,
                                                                disabled:
                                                                    targetPurchaseOrder.status === 'Ordered' ||
                                                                    targetPurchaseOrder.status === 'Rejected' ||
                                                                    targetPurchaseOrder.status === 'Received'
                                                                        ? true
                                                                        : false,
                                                                action: () => {
                                                                    handleDeleteRow(item?.id, getItemSkuForVendor(item?.item));
                                                                },
                                                            },
                                                            {
                                                                type: 'button',
                                                                text: '',
                                                                classType: 'white',
                                                                icon: <HiOutlineExclamationCircle size={'20px'}/>,
                                                                action: () => {
                                                                    handleStatictisItem(item?.item?.id, item?.item?.name);
                                                                },
                                                            },
                                                        ]}
                                                    />
                                                </Table.Cell>
                                            </Table.Row>
                                        );
                                    })}
                                </Table.Body>
                            </Table>
                            {isLoading && <SpinnerComponent/>}
                            {targetPurchaseOrder.status === 'Requested' || targetPurchaseOrder.status === 'Draft' ? (
                                    <div className="group-button-footer">
                                        <div className="left">
                                            <Buttons className="text-secondary border border-secondary"
                                                     onClick={() => addRowFunc()} text={t('orderPage.addSingleItem')}
                                            />
                                            <Buttons
                                                className="text-secondary border border-secondary"
                                                onClick={() => handleAddItemByCategory()}
                                                text={t('orderPage.addItemBycategory')}
                                            />
                                        </div>
                                        <div
                                            className="right">
                                            <Buttons className="text-white bg-gray-400"
                                                 onClick={() => isSaveDraft ? {} : handleSaveDraft(data)}
                                                 text={t('orderPage.saveDraft')}/>
                                            <Buttons className="text-white bg-primary"
                                                     onClick={() => isLoading ? {} : handleUpdatePurchaseOrder(data, 'Requested')}
                                                     text={t('orderPage.saveReview')}/>
                                        </div>
                                    </div>
                                )
                                :
                                ''
                            }
                        </>
                    )}
                </div>
            </div>
            {openModal && (
                <CreateItemByCategoryModal
                    headerTitle={t('categoryPage.chooseCategory')}
                    openModal={openModal}
                    setOpenModal={setOpenModal}
                    category={category}
                    setCategory={setCategory}
                    queryClient={queryClient}
                    setCurrentPage={setCurrentPage}
                    currentPage={currentPage}
                />
            )}
            {openModalStatistics && (
                <StatisticsSaleModal
                    headerTitle={t('stockPage.statisticsSale')}
                    openModal={openModalStatistics}
                    setOpenModal={setOpenModalStatistics}
                    itemName={itemNameChart}
                    data={dataChart}
                />
            )}
            {openMlvedaErrorModal && (
                <MlvedaErrorModal
                    headerTitle={t('orderPage.errorN2gHeader')}
                    openModal={openMlvedaErrorModal}
                    setOpenModal={setOpenMlvedaErrorModal}
                    data={mlvedaError}
                    queryClient={queryClient}
                    setCurrentPage={setCurrentPage}
                    currentPage={currentPage}
                />
            )}
        </>
    );
};

export default PurchaseOrderReview;
